import { createElement } from 'react';
import withStyles, { WithStyles } from 'react-jss';
import flowRight from 'lodash.flowright';
import { observer } from 'mobx-react';
import { store } from '../store';
import Dialog from 'react-dialog';
import 'react-dialog/css/index.css';
import { observable } from 'mobx';
import { Transform } from 'stream';
import ColorPicker from '../components/common/ColorPicker';
import { openDialog } from './DialogElement';

const undo = require('../components/icons/undo.svg');
const redo = require('../components/icons/redo.svg');
const help = require('../components/icons/help.svg');
const newTemplate = require('../components/icons/new-template.svg');
const sendEmail = require('../components/icons/send-email.svg');

const styles = {
    footer: {
        backgroundColor: '#F5F5F5',
        color: '#CDCED1',
        display: 'flex',
        flexDirection: 'row',
        flexBasis: 50,
        justifyContent: 'flex-end',
        padding: '0 10px',
    },
    input: {
        width: 150,
        height: 30,
        margin: 10,
    },

    button: {
        width: 70,
        height: 30,
        cursor: 'pointer',
        margin: '5px',
        backgroundColor: '#051932',
        color: '#fff',
        textTransform: 'uppercase',
        borderRadius: 6,
        border: '2px solid #051932',
        '&:hover': {
            backgroundColor: '#051932',
        },
    },
    button1: {
        width: 'auto',
        height: 30,
        backgroundColor: '#051932',
        color: '#fff',
        textTransform: 'uppercase',
        fontWeight: 500,
        display: 'flex',
        padding: '0 15px',
        cursor: 'pointer',
        borderRadius: 6,
        border: '2px solid #051932',
        margin: '5px',
        '&:hover': {
            backgroundColor: '#051932',
        },
    },
    select: {
        width: 200,
        height: 40,
        borderRadius: 5,
        color: '#CDCED1',
        backgroundColor: '#2F343E',
        border: '1px solid #CDCED1',
    },
    header: {
        margin: 10,
        color: 'black',
    },
    title: {
        float: 'left',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        marginLeft: 20,
        marginTop: 35,
        color: 'black',
        fontSize: 20,
    },
    dialog: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
    },
    footerleft: {
        display: 'flex',
        alignItems: 'center',
        // justifyContent: "space-around"
    },
    footerRight: {
        display: 'flex',
        alignItems: 'center',
        padding: 10,
    },
    imgStyle: {
        marginRight: 3,
    },
};

function createNewTemplate() {
    store.currentTemplate = store.createDefaultTemplate();
}

function sendMail(): Promise<boolean> {
    return new Promise(function(res) {
        if (store.callbacks.testMailCb) {
            res(true);
        }
        res(false);
    });
    // if (store.callbacks.testMailCb) {
    //     store.callbacks.testMailCb(emailDialogState.to, emailDialogState.subject, store.renderTemplate());
    // }
}

let emailDialogState = observable({
    subject: '',
    to: '',
});

interface IProps extends WithStyles<typeof styles> {}

const Footer: React.FunctionComponent<IProps> = ({ classes }) => (
    <div className={classes.footer}>
        <div className={classes.footerleft}>
            <button className={classes.button + ' undo'} onClick={() => store.undo()} title="Undo">
                Undo
            </button>
            <button className={classes.button + ' redo'} onClick={() => store.redo()} title="Redo">
                Redo
            </button>
        </div>

        {store.ui.isTestMailDialogOpen ? (
            <Dialog
                title="Enter Mail Details"
                onClose={() => (store.ui.isTestMailDialogOpen = false)}
                modal={true}
                buttons={[
                    {
                        text: 'Send',
                        onClick: () =>
                            sendMail().then((res) => {
                                res ? ((store.ui.isTestMailDialogOpen = false), (store.ui.isMailConfirmationDialogOpen = true)) : null;
                            }),
                    },
                ]}>
                <div className={classes.dialog}>
                    <span className={classes.header}>Recipient Mail</span>
                    <input type="text" onChange={(e) => (emailDialogState.to = e.target.value)} value={emailDialogState.to} className={classes.input} />
                    <span className={classes.header}>Subject</span>
                    <input type="text" onChange={(e) => (emailDialogState.subject = e.target.value)} value={emailDialogState.subject} className={classes.input} />
                </div>
            </Dialog>
        ) : null}

    </div>
);

export default flowRight([withStyles(styles), observer])(Footer);
